// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Alik","inputDescription":"styles_inputDescription__2P7S6"};